// pages/faq/FAQDetailPage.tsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getFaqDetail, FAQDetailDto } from '../../api/deskApi';

const FAQDetailPage = () => {
    const { seq } = useParams<{ seq: string }>();
    const navigate = useNavigate();
    const [faqData, setFaqData] = useState<FAQDetailDto | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (seq) {
            fetchFaqDetail(Number(seq));
        }
    }, [seq]);

    const fetchFaqDetail = async (faqSeq: number) => {
        try {
            setLoading(true);
            const response = await getFaqDetail(faqSeq);

            if (response.data.code === '00' && response.data.data) {
                setFaqData(response.data.data);
            } else {
                alert('FAQ를 찾을 수 없습니다.');
                navigate('/faq');
            }
        } catch (error) {
            console.error('FAQ 조회 실패:', error);
            alert('FAQ 조회 중 오류가 발생했습니다.');
            navigate('/faq');
        } finally {
            setLoading(false);
        }
    };

    const getCategoryLabel = (category: string) => {
        const categoryMap: { [key: string]: string } = {
            'MEMBER': '회원',
            'SERVICE': '서비스',
            'PAYMENT': '선불',
            'BILLING': '결제',
            'ETC': '기타'
        };
        return categoryMap[category] || category;
    };

    const formatDate = (dateString: string) => {
        if (!dateString) return '';
        return dateString.substring(0, 10);
    };

    const handleFileDownload = (filePath: string, fileName: string) => {
        const link = document.createElement('a');
        link.href = filePath;
        link.download = fileName;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    if (loading) {
        return (
            <div className="app">
                <header className="sub-header">
                    <div className="header-inner">
                        <button type="button" className="backBtn" onClick={() => navigate('/faq')}>
                            <span className="blind">뒤로가기</span>
                        </button>
                        <h1 className="subtitle">자주묻는 질문</h1>
                        <a href="/" className="homeBtn">
                            <span className="blind">홈으로</span>
                        </a>
                    </div>
                </header>
                <main className="container">
                    <div style={{ padding: '40px', textAlign: 'center' }}>
                        <i className="fa fa-spinner fa-spin" style={{ fontSize: '24px' }}></i>
                    </div>
                </main>
            </div>
        );
    }

    if (!faqData) {
        return null;
    }

    return (
        <div className="app">
            {/* 첨부파일 영역 */}
            {faqData.fileList && faqData.fileList.length > 0 && (
                <div className="bottom-btn">
                    <ul className="file-wrap">
                        {faqData.fileList.map((file: any) => (
                            <li key={file.seq}>
                                <a
                                    href="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleFileDownload(file.filePath, file.fileName);
                                    }}
                                >
                                    <p className="file-txt">
                                        <span className="file-tit">{file.fileName}</span>
                                        <span className="ico">
                                            <i className="fa-solid fa-file-arrow-down"></i>
                                        </span>
                                    </p>
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            {/* container */}
            <main className="container">
                <section className="boardHeadline">
                    <div className="inner">
                        <p className="boardTitle">
                            <span style={{
                                display: 'inline-block',
                                padding: '2px 8px',
                                marginRight: '8px',
                                backgroundColor: '#f0f0f0',
                                borderRadius: '4px',
                                fontSize: '12px',
                                color: '#666'
                            }}>
                                {getCategoryLabel(faqData.category)}
                            </span>
                            {faqData.title}
                        </p>
                        <p className="boardDate">{formatDate(faqData.regDate)}</p>
                    </div>
                </section>

                <section className="boardDetail">
                    <div className="inner">
                        <div
                            style={{
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                lineHeight: '1.6'
                            }}
                        >
                            {faqData.answer}
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default FAQDetailPage;